module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer023"
    }
  }, [_c('p', {
    staticClass: "dedication",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“We are stardust")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("We are golden")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And we’ve got to get ourselves")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Back to the garden …”")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("—Joni Mitchell, ")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Woodstocks")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "dedication",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“And those who who seen dancing")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("\twere thought to be insane")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("\tby those who could not hear the music.”")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("—Friedrich Nietzche")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08274547","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/epigraph.vue
// module id = 75
// module chunks = 0